// CTV-466 follow-up: shared Pattern A primary CTA. Gradient pill themed to
// the station accent (or a neutral slate gradient when no station context is
// available — e.g., ResetPasswordPage, the AdvertiserCreativeLibraryPage
// empty-state sign-in). Shape, hover, and shadow are identical across both
// variants so the only thing that changes is the brand color.

import React from 'react';

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  // Station accent color. When omitted, falls back to a neutral slate gradient
  // (used on pre-auth surfaces that don't carry a station config).
  accentColor?: string;
  // Deeper hue used as the gradient endpoint + shadow color. Defaults to
  // accentColor when absent.
  primaryColor?: string;
  size?: 'sm' | 'md';
  fullWidth?: boolean;
  children: React.ReactNode;
}

const NEUTRAL_ACCENT = '#475569';
const NEUTRAL_PRIMARY = '#1e293b';

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  accentColor,
  primaryColor,
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  ...rest
}) => {
  const a = accentColor || NEUTRAL_ACCENT;
  const p = primaryColor || (accentColor ?? NEUTRAL_PRIMARY);
  const pad = size === 'sm' ? 'px-4 py-1.5 text-[12px]' : 'px-5 py-2 text-[13px]';
  return (
    <button
      {...rest}
      className={`inline-flex items-center justify-center gap-1.5 ${pad} ${fullWidth ? 'w-full' : ''} rounded-full font-semibold text-white transition-all hover:brightness-110 active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:brightness-100 ${className}`}
      style={{
        background: `linear-gradient(180deg, ${a}, ${p})`,
        boxShadow: `0 1px 0 rgba(255,255,255,0.25) inset, 0 6px 14px -8px ${p}`,
      }}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
